<template>

  <div id="quotation-products" class="sixteen wide column">

    <product-input v-if="showProductInput" ref="productInput" :quotation="quotation" :product="selectedProduct" 
      :action="productInputAction" @onCancel="setProductInputVisible(false)" @onConfirm="onConfirmProduct" />

    <div v-else class="ui segment animated fadeIn">
      <h4 class="ui dividing header">Produtos</h4>
      <button class="ui basic mini button" :class="{ disabled: !canAddProducts }" @click="onAddProduct()">
        <i class="plus blue icon"></i>
        Adicionar
      </button>
      <button class="ui basic mini button" :class="{ green: autoRecalc }" @click="toggleAutoRecalc()"
        title="Quando desligado, os itens nao sao recalculados a cada insercao; o recalculo ocorre ao salvar.">
        <i class="sync icon" :class="autoRecalc ? 'green' : 'grey'"></i>
        Recálculo automático: {{ autoRecalc ? 'Ligado' : 'Desligado' }}
      </button>
      <div v-if="!autoRecalc" class="ui small warning message" style="margin-top: 8px">
        <i class="info circle icon"></i>
        Recálculo automático <strong>desligado</strong> — os preços/descontos exibidos podem não refletir a faixa final; serão recalculados ao salvar.
      </div>
      <table v-if="quotation.items.length > 0" class="ui very basic selectable celled tablet stackable table">
        <thead class="desktop-only">
          <tr>
            <th>Produto</th>
            <th>Quantidade</th>
            <th>Preço Padrão</th>
            <th>Preço Sugerido</th>
            <th>Preço Aprovado</th>
            <th>Total Aprovado</th>
            <th>% Comissão</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in quotation.items" :key="index" class="clickable" @click="onUpdateProduct(index)">
            <td>
              <span v-html="item.status.html"></span>
              {{ item.description }}
              <span v-if="item.idReserve" class="ui small label m-l-10">
                <i class="info circle icon"></i>Reserva {{ item.idReserve }}
              </span>
            </td>
            <td :class="{ 'red text': item.quantityAlert }"><strong class="mobile-only">Quantidade: </strong>
              {{ $formatInteger(item.quantity) }}
            </td>
            <td>
              <strong class="mobile-only">Preço Padrão: </strong>
              R$ {{ $formatCurrencyWith4Decimals(item.stdPrice || item.minPrice) }}
            </td>
            <td :class="{ 'red text': item.sugPriceAlert }">
              <strong class="mobile-only">Preço Sugerido: </strong>
              R$ {{ $formatCurrencyWith4Decimals(item.sugPrice) }}
            </td>
            <td :class="{ 'red text': item.appPriceAlert }">
              <strong class="mobile-only">Preço Aprovado: </strong>
              R$ {{ $formatCurrencyWith4Decimals(item.appPrice) }}
            </td>
            <td>
              <strong class="mobile-only">Total Aprovado: </strong>
              R$ {{ $formatCurrency(item.appTotal) }}
            </td>
            <td>
              <strong class="mobile-only">% Comissão: </strong>
              {{ $formatCurrency(item.sugCommission) }}%
            </td>
            <td>
              <button type="button" class="ui mini icon button" @click="onRemoveItem($event, index)">
                <i class="times icon"></i>
              </button>
            </td>
          </tr>            
        </tbody>
      </table>
      <div class="ui grid m-t-20">
        <div class="eight wide column">
          <div class="ui small label">
            <i class="info circle icon"></i>
            {{ infoLabel }}
          </div>
        </div>
        <div class="eight wide column">
          <div v-if="sugTotal > 0" class="ui basic right aligned segment no-margin no-padding animated fadeIn" 
              style="margin-right: 15px !important;">
            <strong class="m-r-5">Total Sugerido: </strong>  R$ {{ $formatCurrency(sugTotal) }}
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import ProductInput from "./product-input.vue"
  import QuotationService from "@/services/quotation-service"
  import OppBalanceService from "@/services/opp-balance-service"
  import { Loader, Scroll } from "@/utils"
  import debounce from "debounce"

  export default {

    data() {
      return {
        showProductInput: false,
        selectedProduct: {},
        selectedIndex: null,
        productInputAction: "",
        branchId: "",
        reserveId: "",
        // Lentidao (477272): recalculo automatico de todos os itens a cada insercao/edicao.
        // Default LIGADO (comportamento atual); o usuario DESLIGA p/ pedidos grandes (insercao
        // instantanea). Em ambos os casos o recalculo completo e' garantido ao salvar. Preferencia persistida.
        autoRecalc: window.localStorage.getItem("quotationAutoRecalc") !== "false"
      }
    },

    components: {
      ProductInput,
    },

    props: ["quotation", "isCreating", "isUpdating"],

    // Mod001 Performance: cria a versao debounced de updateAllPrices por instancia
    created() {
      this.queueUpdateAllPrices = debounce(this.updateAllPrices, 400)
    },

    beforeDestroy() {
      if (this.queueUpdateAllPrices && typeof this.queueUpdateAllPrices.clear === "function") {
        this.queueUpdateAllPrices.clear()
      }
    },

    computed: {

      infoLabel() {

        if (!(this.quotation && this.quotation.customer && this.quotation.freight && this.quotation.paymentCondition))
          return "Informe o cliente, o frete e a condição de pagamento"

        if (this.quotation.isRetail == undefined)
          return "Defina se é uma venda para varejo"

        let label = ""
        const itemsCount = this.quotation.items.length        

        if (itemsCount == 0) {
          label = "Nenhum item adicionado"
        } else if (itemsCount == 1) {
          label = "1 item adicionado"
        } else {
          label = itemsCount + " itens adicionados"
        }

        return label
      },

      canAddProducts() { 
        
        let canAdd = false

        if (this.quotation && this.quotation.customer && this.quotation.freight && this.quotation.paymentCondition)
          canAdd = true

        if (this.quotation.isRetail == undefined)
          canAdd = false  
        
        return canAdd
      },

      sugTotal() {

        let sugTotal = 0

        this.quotation.items.forEach((item) => sugTotal += item.sugTotal)

        return sugTotal
      },
    },

    methods: {

      // Lentidao (477272): liga/desliga o recalculo automatico (persiste a preferencia).
      // Ao LIGAR, recalcula uma vez para sincronizar itens que ficaram defasados com o toggle off.
      toggleAutoRecalc() {
        this.autoRecalc = !this.autoRecalc
        window.localStorage.setItem("quotationAutoRecalc", this.autoRecalc ? "true" : "false")
        if (this.autoRecalc)
          this.queueUpdateAllPrices()
      },

      onAddProduct() {
        
        this.selectedIndex = null
        this.selectedProduct = {}
        this.productInputAction = "add"

        this.setProductInputVisible(true)
      },      

      onUpdateProduct(index) {

        this.selectedIndex = index
        this.selectedProduct = this.quotation.items[index]
        this.productInputAction = "update"

        this.setProductInputVisible(true)
      },

      onConfirmProduct(item) {

        if (this.productInputAction == "add") {

          this.quotation.items.push(item) //trabalhar aqui com o idReserve

        } else {

          let items = this.quotation.items.slice()

          items[this.selectedIndex] = item

          this.quotation.items = this.$cloneObject(items)
        }

        this.$emit("onChange")

        this.setProductInputVisible(false)

        // Lentidao (477272): so recalcula todos os itens automaticamente se o toggle estiver ligado.
        // Desligado, o item novo ja foi precificado pelo product-input; o recalculo completo ocorre
        // ao salvar (form.onConfirm). Mod001: debounce 400ms agrupa adicoes consecutivas.
        if (this.autoRecalc)
          this.queueUpdateAllPrices()
      },

      onRemoveItem($event, index) {
        if (this.quotation.items[index].idReserve) {
          this.branchId = this.quotation.items[index].branchReserve
          this.reserveId = this.quotation.items[index].idReserve
          this.onConfirmCancel()
        }

        $event.stopPropagation()
        this.quotation.items.splice(index, 1)
        this.$emit("onChange")

        // Lentidao (477272): respeita o toggle (ver onConfirmProduct)
        if (this.autoRecalc)
          this.queueUpdateAllPrices()
      },

      setProductInputVisible(visible) {

        this.showProductInput = visible

        Scroll.toElement("#quotation-products")

        this.$emit("onProductInput", visible)
      },      

      async updateAllPrices() {

        if (this.quotation.items.length == 0)
          return

        Loader.show("Atualizando preços...")

        try {

          // Mod001 Performance: uma unica chamada HTTP para o backend recalcular todos os itens.
          // Erro21397 (477268): o appPrice e definido EXCLUSIVAMENTE pelo applyPriceData dentro do
          // recalcBatch, que aplica a regra v4 (preserva a aprovacao manual quando o PRECO SUGERIDO
          // nao muda, mesmo que o minPrice mude por faixa/carta; zera quando o sug muda ou cai de
          // fato abaixo do minimo). O loop antigo de re-invalidacao por minPrice/appPriceChanged foi
          // removido por SOBREPOR e desfazer essa regra v4 a cada alteracao (a oscilacao do total
          // durante a edicao trocava de faixa, mudava o minPrice e zerava aprovacoes manuais).
          await QuotationService.recalcBatch(this.quotation)

          this.quotation.items.forEach((item, index) => {
            QuotationService.updateItemData(item)
            this.quotation.items[index] = this.$cloneObject(item)
          })

          this.$emit("onChange")

        } catch (error) {
          this.$errorHandler()
        }

        Loader.hide()

      },
      
      async onConfirmCancel() {
        try {
          await OppBalanceService.cancel(this.branchId, this.reserveId)
          this.setAsCanceledInStore()   
        } catch (error) {
          this.$errorHandler(error)
        }
      },

      setAsCanceledInStore() {

        if (!this.$store.state.reserves)
          return

        let newReserves = []
        let reserves = this.$store.state.reserves.slice()   
        let filter = this.$store.state.reservesFilter       

        reserves.forEach((reserve) => {

          if (reserve.balance.branch.id == this.branchId && reserve.id == this.reserveId)
            this.setReserveCanceled(reserve)          

          if (!filter.status || reserve.status == filter.status)
            newReserves.push(reserve)
        })

        this.$store.commit("setReserves", newReserves)
      },
    },
  }

</script>

